import QueryKeyFactory from "../../../api/hooks/utils/queryKeyFactory";

export const sharepointKeys = new QueryKeyFactory('sharepoint')

